import { axios } from '@/utils/request';

let Api = {
  history: '/tech/get_demand_achievement_analysis_history', // 成果、需求 历史记录
  deleteHistory: '/tech/delete_history', // 删除历史记录
};

// 成果、需求 历史记录
export const historyApi = (params) => {
  return axios.get(Api.history, { params } );
};

// 删除历史记录
export const deleteHistory = (params) => {
  return axios.get(Api.deleteHistory, { params });
};